/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_House_Promo_Strip_TitleInputs */

const en_directory_house_promo_strip_title = /** @type {(inputs: Directory_House_Promo_Strip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`While you wait, try a tool from our team`)
};

const zh_directory_house_promo_strip_title = /** @type {(inputs: Directory_House_Promo_Strip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等待审核时，不妨试试我们团队的工具`)
};

/**
* | output |
* | --- |
* | "While you wait, try a tool from our team" |
*
* @param {Directory_House_Promo_Strip_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_house_promo_strip_title = /** @type {((inputs?: Directory_House_Promo_Strip_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_House_Promo_Strip_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_house_promo_strip_title(inputs)
	return zh_directory_house_promo_strip_title(inputs)
});
export { directory_house_promo_strip_title as "directory.house_promo.strip_title" }